<template>
  <div
    id="canvas-container-animation-spine-winterbonusjagd-kingspass"
    ref="canvascontainer"
    :style="{ opacity: containerOpacity }"
    class="canvas-container-animation-spine-winterbonusjagd-kingspass"
  ></div>
</template>

<script>
import AnimationSpineBaseFunctions from "@/components/animation/animation-spine-base-functions";
import sound_super_win from "@/assets/sound/animation/adelsliga-aufstieg-fanfare.mp3";

export default {
  name: "AnimationWinterbonusjagdKingspass",
  mixins: [AnimationSpineBaseFunctions],
  props: {
    loop: {
      type: Boolean,
      default: true,
    },
    run: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      containerId: "canvas-container-animation-spine-winterbonusjagd-kingspass",
      json: "/assets/spines/events/winterbonusjagd/winterbonusjagd-getpass.json",
      atlas:
        "/assets/spines/events/winterbonusjagd/winterbonusjagd-getpass.atlas",
    };
  },

  watch: {
    run: function () {
      this.activateAnimation("main", false);
    },
    completed() {
      if (this.completed) {
        this.$emit("kingspass-ani-completed");
      }
    },
  },
  mounted() {
    this.setupAnimation("main", this.onSuccess);
  },

  methods: {
    onSuccess() {
      this.containerOpacity = 1;
      const text = document.createElement("div");
      text.innerHTML = this.$t("events.winter.kingspass_received");
      text.classList.add("text1", "to-center-abs");
      this.$refs.canvascontainer.appendChild(text);
      this.showText(text);
      this.playSoundEffect(sound_super_win, false, 0.7);
      this.spinePlayer.animationState.addListener({
        complete: () => {
          this.$emit("kingspass-ani-completed");
        },
      });
    },
    showText(element) {
      const timeline = this.gsap.timeline();
      timeline
        .to(
          [element],
          0,
          {
            onComplete: () => {
              this.playSoundEffect(sound_super_win, false, 0.7);
            },
          },
          0
        )
        .fromTo(
          [element],
          0.8,
          {
            scale: 0,
          },
          {
            ease: "elastic",
            scale: 1,
          },
          1
        );
    },
  },
};
</script>

<style lang="scss">
.canvas-container-animation-spine-winterbonusjagd-kingspass {
  pointer-events: none;
  width: 1121px;
  height: 715px;
  position: relative;

  canvas {
    position: absolute;
    z-index: 1000;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 100%;
    height: 100%;
  }

  .text1 {
    font-family: Ubuntu-Medium;
    color: white;
    background: none;
    text-shadow: 1px 1px 2px #1ae5f4, 0 0 25px #1ae5f4, 0 0 5px #1ae5f4 !important;
    font-size: 60px;
    -webkit-text-fill-color: white;
    transform: scale(0);
    z-index: 1001;
    text-transform: uppercase;

    position: absolute;
    top: 80%; // Adjust if needed
    left: 50%;
    transform: translateX(-50%) scale(0); // Center and keep scale(0) for GSAP
    white-space: nowrap;
  }
}
</style>
